import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[validYears]'
})
export class ValidYearsDirective {

  constructor(private control: NgControl) {}
  
    @HostListener('blur', ['$event'])
    onInput(event: Event) {
      const inputElement = event.target as HTMLInputElement;
      const rawValue = inputElement.value;
  
      if (rawValue === '') {
        return;
      }
  
      const numericValue = Number(rawValue);
      const currentYear = new Date().getFullYear();
      if (isNaN(numericValue)) {
        return;
      }
  
      if (numericValue < 2020) {
        this.control.control.setValue(2020);
      } else if (numericValue > currentYear) {
        this.control.control.setValue(currentYear);
      }
    }
  
    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent) {
      const allowedKeys = /[0-9]/;
      if (!allowedKeys.test(event.key)) {
        event.preventDefault();
      }
    }

}
